(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["jib-campaign-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jib-campaign-intro"]) return;
  try {
    
if (!customElements.get('jib-campaign-intro')) {
  customElements.define('jib-campaign-intro', class extends HTMLElement {
    connectedCallback() {
      const restore = () => {
        const campaign = this.querySelector('[data-campaign]');
        const fallback = this.querySelector('[data-fallback]');
        if (campaign) campaign.hidden = true;
        if (fallback) fallback.hidden = false;
      };
      const checkExpiry = () => {
        const remaining = Number(this.dataset.end) - Date.now();
        if (remaining <= 0) restore();
        else this.expiryTimer = setTimeout(checkExpiry, Math.min(remaining, 2147483647));
      };
      checkExpiry();
    }
    disconnectedCallback() { clearTimeout(this.expiryTimer); }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
